import {RequestAnfrage} from "../../model/request.anfrage";

/**
 * Class holds all the data of the request inside the heizcheck that the user needs for the frontend.
 */
export class HeizcheckAnfrage implements RequestAnfrage {

  /**
   * holds the last update we did on the local data
   */
  lastupdate: number;

  /**
   * Holds the last (location) path that the user has seen.
   */
  lastPath: string;

  /**
   * The users input for heating bills
   */
  heizkostenanalyseInput: any = {};

  /**
   * Result from the heatingbill API
   */
  heizkostenanalyseResult: any = {};

  /**
   * Input of the first chapter
   */
  verbrauchsanalyseInput: any = {};

  /**
   * The calculated result for the first chapter
   */
  verbrauchsanalyseResult: any = {};

  /**
   * data/fields that where detected by the KI
   */
  detectedData: any = {};

  /**
   * holds the currecnty active portalId for this request
   */
  portalId: string;

  /**
   * result of the user's dialog registration
   */
  dialogResult: string = null;

  /**
   * @inheritdoc
   */
  campaignId: string = null;
}
